 (function () {  
    async function insertSectionCartDrawer() {
      if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return

      var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
      if (!cartDrawerItems) return

      if (cartDrawerItems.classList.contains('is-empty')) return

      var wrapper = document.createElement('div')
      wrapper.classList.add('cart-drawer-items-wrapper')
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
      wrapper.appendChild(cartDrawerItems)

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      if (upsells) wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML)
 
      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        wrapper.querySelector('#cart-drawer-upsell')?.remove()  
      }
    }
    insertSectionCartDrawer()

  /*  async function insertSectionCartPage() {
      const cartItems = document.querySelector('cart-items')
      if (!cartItems) return

      const existingUpsells = document.querySelector('#MainContent #cart-drawer-upsell')
      if (existingUpsells) {
        existingUpsells.remove()
      }

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        wrapper.querySelector('#cart-drawer-upsell')?.remove()  
      }
    }
    insertSectionCartPage() */
    
    window.onChangeKsUpsellVariantSelector = function( select, event) {
      event.preventDefault()
      const selected = select.options[select.selectedIndex];
      const price = select.closest('.cart-drawer-upsell-list-item').querySelector('.kima-upsell-price');
      if (price && !price.dataset.fixedOffer) {
        price.replaceChildren();
        if (selected.dataset.compare) { const old = document.createElement('s'); old.textContent = selected.dataset.compare; price.append(old); }
        const amount = document.createElement('span'); amount.textContent = selected.dataset.price; price.append(amount);
      }
      const imgSrc = selected.dataset.variantImg

      if (imgSrc) {
        const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img')
        img.src = imgSrc
      }
    }

    function listenCartDrawer() {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      let pending = false;
      let refreshAgain = false;
      async function refresh() {
        const items = drawer.querySelector('cart-drawer-items');
        if (!items || items.classList.contains('is-empty') || items.closest('.cart-drawer-items-wrapper')) return;
        if (pending) { refreshAgain = true; return; }
        pending = true;
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('section_id', 'cart-drawer');
          const response = await fetch(url, { headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error('Upsell refresh failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = doc.querySelector('#cart-drawer-upsell-wrapper');
          const currentSource = document.querySelector('#cart-drawer-upsell-wrapper');
          // Ignore a response for cart items that have since been replaced.
          if (source && currentSource && items === drawer.querySelector('cart-drawer-items')) {
            currentSource.replaceWith(source);
            insertSectionCartDrawer();
          } else if (items !== drawer.querySelector('cart-drawer-items')) {
            refreshAgain = true;
          }
        } catch (error) {
          console.warn('KIMA cart recommendations could not refresh', error);
        } finally {
          pending = false;
          if (refreshAgain) { refreshAgain = false; refresh(); }
        }
      }
      new MutationObserver(refresh).observe(drawer, { childList: true, subtree: true });
    }
    listenCartDrawer();
  })();
